export const getThirdPartyLicensesHaynesRequest = () => ({
  method: 'GET',
  url: '/modules/third-party-licenses/haynes'
})
